import Reddit from '../components/Reddit';
import { connect } from 'react-redux';
import moreReducer from '../store/reducers/more';
import reduce from '../store/reduce';

const mapStateToProps = ({ data, ui }) => {
	let subreddit, after;
	let comments, moreComments, commentId;

	if (data.subreddit.threads.length > 0) {
		const threads = data.subreddit.threads;
		const threadsCount = threads.length;
		after = threads[threadsCount - 1].linkId;
		subreddit = data.subreddit.subreddit;
	}

	const subredditSortBy = data.subreddit.sortBy;
	const commentsSortBy = data.comments.sortBy;

	moreComments = data.comments.moreComments;
	commentId = data.comments.linkData.id;

	return {
		subreddit,
		after,
		comments,
		moreComments,
		commentId,
		subredditSortBy,
		commentsSortBy,
		routeLoading: data.loading?.route,
		otherLoading: data.loading?.other
	};
};

const mapDispatchToProps = dispatch => ({
	clearCommentsMore: () => dispatch(moreReducer.saveCommentsMore({ commentsMore: null })),
	appendSubreddit: ({threads, subreddit}) => dispatch(reduce.subreddit.appendSubreddit({ threads, subreddit })),
	appendComments: ({moreComments, commentId}) => dispatch(reduce.comments.appendComments({ moreComments, commentId }))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{ forwardRef: true }
)(Reddit);
